import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'polist' })
export class PoListPipe implements PipeTransform {
    transform(value:any[],searchText:string ){

       if(!searchText){
      //   console.log('no search')
         return value  
       }

       return value.filter(it=>{   
           const ponumber = it.ponumber.toString().toLowerCase().includes(searchText.toLowerCase())
           const requestername = it.requestername.toLowerCase().includes(searchText.toLowerCase())
		    const vendorname = it.vendorname.toLowerCase().includes(searchText.toLowerCase())
			  const costcenter = it.costcentername !==null? it.costcentername.toLowerCase().includes(searchText.toLowerCase()) : value
			 const description = it.description !==null? it.description.toLowerCase().includes(searchText.toLowerCase()) : value
          
           return (ponumber + requestername  + vendorname + description + costcenter);      
       }) 
    }
}